<template>
  <div id="reimbursement">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit" class="detail-form">
      <uploader :imgUrl="postForm.health_code_img" @changeImage="changeHealthCodeImg" :title="postForm.health_code_img_title"></uploader>
      <van-divider :style="{margin: '0 20px'}" />
      <uploader :imgUrl="postForm.trajectory_img" @changeImage="changeTrajectoryImg"  :title="postForm.trajectory_img_title"></uploader>
      <van-divider :style="{margin: '0 20px'}" />
      <uploader :imgUrl="postForm.nucleic_img" @changeImage="changeNucleicImg" :title="postForm.nucleic_img_title"></uploader>

      <div style="margin: 16px;width: 300px; margin: 0 auto;">
        <van-button type="info" @click="goBack" style="width: 80px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-left: 50px;" native-type="button">返回</van-button>
        <van-button type="info" style="width: 80px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-left: 50px;" native-type="submit">保存</van-button>
        <div clear="both"></div>
      </div>
    </van-form>
  </div>
</template>
<script>
import Uploader from '../../user/components/uploader'
import {updateAnnexManInfo} from '@/api/user'
import {Toast} from 'vant'

export default {
  name: 'updateInfo',
  components: {
    Uploader
  },
  props: {
    showContent: {
      type: Object,
      default: null
    },
    annexId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      title: '更新个人信息',
      postForm: {
        health_code_img: '',
        trajectory_img: '',
        nucleic_img: '',
        health_code_img_title: '健康码',
        trajectory_img_title: '行动报告',
        nucleic_img_title: '核酸检测图片'
      }
    }
  },
  methods: {
    onSubmit() {
      updateAnnexManInfo(this.annexId, this.postForm).then((res) => {
        if (res.data.code === 0) {
          Toast('更新成功');
          this.$emit('hideInfo', null)
        }
      })
    },
    goBack() {
      this.$emit('hideInfo')
    },
    changeHealthCodeImg(obj) {
      this.postForm.health_code_img = obj
    },
    changeTrajectoryImg(obj) {
      this.postForm.trajectory_img = obj
    },
    changeNucleicImg(obj) {
      this.postForm.nucleic_img = obj
    },
    onClickLeft() {
      this.$emit('hideInfo')
    }
  }
}
</script>

<style scoped>
  .detail-form {
    width: 90%;
    margin: 10px auto;
    border-radius: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/components/update_info.vue